import { useQuery } from "react-query";
import { getCatalogDataId } from "../catalogApi";

export default function useGetDataCatalogApplicationsId(id) {
  return useQuery({
    queryKey: ["getCatalogData", id],
    queryFn: () => getCatalogDataId(id),
    refetchOnWindowFocus: false,
    enabled: !!id,
  });
}
